var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"marketplace",class:{ 'marketplace--scrolled': _vm.user_scroll_depth !== 0 }},[_c('Header'),_c('section',{staticClass:"marketplace-content"},[_c('router-view',{attrs:{"name":"marketplace_content"}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }